import Page from './index';

export default { path: '/home/msgChannelManage', component: Page };
